// Global variables
let DEBUG_MODE = true;
let isLoading = true;
const VAT_MODE = "NET"; // "NET" or "VAT"
const FREE_SHIPPING_TOTAL = 150;
const TIER_FIVE_LIMIT = 350;
const TIER_SEVENPOINTFIVE_LIMIT = 1000;
const TIER_TEN_LIMIT = 1500;
let lineSubtotals
let cartObject
let shopifyCartObj
let csappsWatcher = null;
let isCartPage = false
let isCartOpen = false
let reloadCount = 0
let isRefreshing = false;
let refreshAttempts = 0;
const MAX_REFRESH_ATTEMPTS = 1;

// Key elements 
const cartLinesContainerId = "cart-items"
const triggerElementClass = ".csapp-price-wrapper";
const loadingOverlayClass = ".cart-item__loader"
const noticeBannerId = "free-shipping-notice"
const lineUnitPriceId = "lineUnitPrice"
const sideCartPageTotalId = "drawer-total-container"
const cartPageTotalId = "cartTotalContainer"
const cartLinePriceContainerClass = ".cart-price-container"
const cartVariantsTextClass = ".cart-item__variants"
const lineSubtotalContainerId = "#lineTotal"
const lineSubTotalDiscountClass = ".cs_final_price"
const lineSubTotalNoDiscountClass = ".price__current"

// Sync the cart with the global object
const waitForCartSync = (expectedItemCount, timeout = 5000) => {
    return new Promise((resolve) => {
        const startTime = Date.now();

        DEBUG_MODE && console.log('⏳ Waiting for cart sync...', {
            shopifyCartQty: expectedItemCount,
            discountAppQty: getCartItemQuantity(window.csapps)
        });

        const checkSync = setInterval(() => {
            const currentQuantity = getCartItemQuantity(window.csapps);
            const elapsed = Date.now() - startTime;

            // Success: quantities match
            if (currentQuantity === expectedItemCount) {
                clearInterval(checkSync);
                DEBUG_MODE && console.log('✅ Cart synced!', {
                    discountAppQty: currentQuantity,
                    elapsed: `${elapsed}ms`
                });
                resolve(window.csapps);
            }

            // Timeout: quantities don't match
            if (elapsed >= timeout) {
                clearInterval(checkSync);
                DEBUG_MODE && console.log('⚠️ Cart sync timeout', {
                    shopifyCartQty: expectedItemCount,
                    discountAppQty: currentQuantity,
                    elapsed: `${elapsed}ms`
                });
                // Resolve anyway with current data
                // resolve(window.csapps);
                resolve(false);
            }
        }, 40); // Check every 50ms
    });
};

// Get item quantity from the csapps object
const getCartItemQuantity = (csapps) => {
    if (!csapps?.fire_cart_ajax?.responseJSON?.cdata?.items) return 0;

    return csapps.fire_cart_ajax.responseJSON.cdata.items.reduce((total, item) => {
        // Skip null items
        if (!item) return total;
        return total + (item.quantity || 0);
    }, 0);
};

// Get item quantity from the cart
const getCurrentCartQuantity = async () => {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        DEBUG_MODE && console.log("Shopify cart", cart)
        shopifyCartObj = cart
        // Sum up quantities from all items
        return cart.items.reduce((total, item) => total + item.quantity, 0);
    } catch (error) {
        x
        DEBUG_MODE && console.error('Failed to get cart quantity:', error);
        return getCartItemQuantity(window.csapps);
    }
};

// Does discount object exist logic
const waitForCsappGlobalObject = (propName, timeoutMs) => {
    return new Promise((resolve, reject) => {
        // Immediate check
        if (window[propName] !== undefined) {
            DEBUG_MODE && console.log("csapps global object exists before check");
            return resolve(window[propName]);
        }

        // If no timeout provided, wait forever
        const hasTimeout = typeof timeoutMs === 'number';
        const start = hasTimeout ? performance.now() : null;

        let resolved = false; // Add flag to prevent multiple calls

        const check = () => {
            if (resolved) return; // Stop if already resolved/rejected

            if (window[propName] !== undefined) {
                DEBUG_MODE && console.log("csapps global object exists after check");
                resolved = true;
                resolve(window[propName]);
                return;
            }

            if (hasTimeout && performance.now() - start >= timeoutMs) {
                DEBUG_MODE && console.log("csapps global object check timed out");
                resolved = true;
                reject(new Error(`Timeout waiting for window.${propName}`));
                return;
            }

            try {
                requestAnimationFrame(check);
            } catch (err) {
                DEBUG_MODE && console.log("ERR in", err)
            }
        };

        try {
            requestAnimationFrame(check);
        } catch (err) {
            DEBUG_MODE && console.log("ERR out", err)
        }
    });
};

// Maths for updating prices 
const justNumbers = (inputString) =>
    typeof inputString === "string" ? inputString.replace(/[^0-9\.]+/g, "") : inputString;
const getNet = (gross) => (parseFloat(gross) / 6) * 5;


// Show elements functions
const revealPrices = (fallback) => {
    // Takes off the opacity to show prices, fallback property is boolean and shows reveals in green for debugging     
    const priceContainers = document.querySelectorAll(cartLinePriceContainerClass)

    if (fallback) {
        priceContainers.forEach((containerElem) => {
            containerElem.style.color = "darkGreen";
        })
    }

    // Show totals box 
    if (isCartPage) {
        document.getElementById(cartPageTotalId).style.opacity = 1
        priceContainers.forEach((containerElem) => {
            containerElem.style.opacity = 1;
        });
    } else {
        priceContainers.forEach((containerElem) => {
            containerElem.style.opacity = 1;
        });
        const sideCartTotalsElem = document.getElementById(sideCartPageTotalId)
        if (sideCartTotalsElem) sideCartTotalsElem.style.opacity = 1
    }

    // Move backorder messages to price containers
    showBackorderedMessage();
}

const showBackorderedMessage = () => {
    DEBUG_MODE && console.log("Checking for backorder messages");

    const cartLinesContainerElem = document.getElementById(cartLinesContainerId);
    if (!cartLinesContainerElem) {
        DEBUG_MODE && console.log("Cart lines container not found");
        return;
    }

    // Get all cart line items
    const cartLineElems = cartLinesContainerElem.querySelectorAll('[data-variant-id]');

    cartLineElems.forEach((lineElem) => {
        const backorderElem = lineElem.querySelector('.backorder');
        const priceContainer = lineElem.querySelector(cartLinePriceContainerClass);

        if (backorderElem && priceContainer) {
            const productTitle = lineElem.querySelector('.cart-item__title')?.innerText ?? 'Unknown product';
            DEBUG_MODE && console.log(`Moving backorder message for: ${productTitle}`);

            // Check if backorder message is not already hidden
            if (!backorderElem.hasAttribute('hidden') && backorderElem.style.display !== 'none') {
                // Remove from current location and append to price container
                priceContainer.appendChild(backorderElem);

                // Make it visible and style appropriately
                backorderElem.style.display = 'block';
                backorderElem.style.marginTop = '0.5rem';
                backorderElem.style.fontSize = '0.875rem';
                backorderElem.style.color = 'rgba(var(--text-color) / .8)';

                DEBUG_MODE && console.log(`Backorder message moved for: ${productTitle}`);
            }
        }
    });

    DEBUG_MODE && console.log("Backorder message check complete");
}

const createTaxLines = (containerElement, grossPrice) => {
    const createMoneySpanTotal = document.createElement("span");
    const showIncTax = document.createElement("span");
    createMoneySpanTotal.id = "totalCartWithPrice";
    createMoneySpanTotal.className = "money";
    createMoneySpanTotal.innerText = formatFinance(grossPrice);
    createMoneySpanTotal.style.fontSize = "16px !important";
    showIncTax.appendChild(createMoneySpanTotal);
    showIncTax.className = "show-cart-total-inc";
    containerElement.appendChild(showIncTax);
};

const cartTotalChanges = (cartObject) => {
    const addedLines = document.getElementById("totalCart");
    const taxLine = document.getElementById("totalTax");
    const cartPricePence = returnTotalCart(cartObject);
    const cartPrice = cartPricePence / 100;
    const cartTotalNetPrice = justNumbers(cartPrice);
    const cartTotalGrossPrice = justNumbers(cartPrice) * 1.2;

    // Check if ex VAT span already exists, if so update it, otherwise create it
    let exVatSpan = addedLines.querySelector('.show-cart-total-ex');
    if (exVatSpan) {
        const moneySpan = exVatSpan.querySelector('.money');
        if (moneySpan) {
            moneySpan.innerHTML = formatFinance(cartPrice);
        }
    } else {
        const newElem = document.createElement("span");
        newElem.innerHTML = `<span class="money">${formatFinance(cartPrice)}</span>`;
        newElem.className = "show-cart-total-ex";
        addedLines.insertBefore(newElem, addedLines.children[0]);
    }

    // Check if inc VAT span already exists, if so update it, otherwise create it
    let incVatContainer = addedLines.querySelector(".show-cart-total-inc");
    if (incVatContainer) {
        const totalIncVat = incVatContainer.querySelector("#totalCartWithPrice");
        if (totalIncVat) {
            totalIncVat.innerText = formatFinance(cartTotalGrossPrice);
        }
    } else {
        createTaxLines(addedLines, cartTotalGrossPrice);
    }

    if (taxLine) {
        taxLine.innerText = formatFinance(cartTotalGrossPrice - cartTotalNetPrice);
    }
}

const returnTotalCart = (cartObject) => { // show top totals
    DEBUG_MODE && console.log("Total cart price fired");
    const cartPriceContainer = document.getElementById("totalCartPrice");
    const twoda = cartPriceContainer.querySelector(".csapps-cart-original-total");

    const cartSubtotal = lineSubtotals;

    // Check if csapps-cart-total already exists
    let existingTotal = cartPriceContainer.querySelector(".csapps-cart-total");

    if (existingTotal) {
        // Update existing element
        const moneySpan = existingTotal.querySelector(".money");
        if (moneySpan) {
            moneySpan.innerText = cartSubtotal;
        }
    } else {
        // Create new element
        const addPrice = document.createElement("span");
        addPrice.innerHTML = `<span class="csapps-cart-total"><span class="money">${cartSubtotal}</span></span>`;
        twoda.parentElement.appendChild(addPrice);
    }

    return cartSubtotal;
};

const formatFinance = (number) =>
    new Intl.NumberFormat("en-UK", {
        style: "currency",
        currency: cartObject.currency_code,
    }).format(number);

const displayPrice = (priceInPence) => `${cartObject.currency_symbol}${parseFloat(priceInPence / 100).toFixed(2)}`

const showPrices = (cartObject, changedVariantId = null) => {

    const getLinePriceElements = (lineElem) => {
        const lineProductTitle = lineElem.querySelector(".cart-item__title")?.innerText ?? "Unknown product";

        const subtotalContainer = lineElem.querySelector(lineSubtotalContainerId);
        const subtotalField = subtotalContainer.querySelector(lineSubTotalDiscountClass) ?? subtotalContainer.querySelector(lineSubTotalNoDiscountClass) ?? null;

        const unitPriceField = lineElem.querySelector(`#${lineUnitPriceId}`);
        const qty = parseInt(lineElem.querySelector("input").value);

        // Has a sale price? render besides. 
        const compareAtPriceField = lineElem.querySelector(".price__was");

        if (compareAtPriceField) {
            DEBUG_MODE && console.log(`${lineProductTitle} product is on sale`)
        }
        const compareAtPrice = compareAtPriceField?.innerText;

        if (compareAtPrice && compareAtPrice.length > 0) {
            // Create sibling element for unit compare at price
            const compareAtPriceElement = document.createElement("s");
            compareAtPriceElement.className = "price__compare-at";
            compareAtPriceElement.id = "product__compareAtUnitPrice";
            compareAtPriceElement.style.fontSize = "0.8em";
            compareAtPriceElement.style.marginLeft = "0.25rem";
            compareAtPriceElement.style.color = "rgba(var(--text-color) / .8)";
            compareAtPriceElement.innerText = compareAtPrice;

            // Insert the new element before the unitPriceField
            if (unitPriceField.parentNode && !unitPriceField.parentNode.querySelector('.price__compare-at')) {
                unitPriceField.after(compareAtPriceElement);
            }

            // Create sibling element for subtotal compare at price
            const compareAtSubtotalElement = document.createElement("s");
            compareAtSubtotalElement.className = "price__compare-at-subtotal";
            compareAtSubtotalElement.id = "product__compareAtSubtotal";
            compareAtSubtotalElement.style.fontSize = "0.8em";
            compareAtSubtotalElement.style.marginLeft = "0.25rem";
            compareAtSubtotalElement.style.color = "rgba(var(--text-color) / .8)";
            compareAtSubtotalElement.innerText = formatFinance(justNumbers(compareAtPrice) * qty);

            // Insert before the subtotal field
            if (subtotalField.parentNode && !subtotalField.parentNode.querySelector('.price__compare-at-subtotal')) {
                subtotalField.after(compareAtSubtotalElement);
            }

            const unitPriceElemFromDOM = lineElem.querySelector("#product__compareAtUnitPrice");
            const subtotalElemFromDOM = lineElem.querySelector("#product__compareAtSubtotal");

            // Hide the original field
            compareAtPriceField.style.display = "none";
        }

        if (!subtotalField || !unitPriceField) throw new Error("Error loading discounts on products, could not locate price fields");

        return { subtotalField, unitPriceField }
    }

    const cartLinesContainerElem = document.getElementById(cartLinesContainerId)

    // Reset lineSubtotals at the start of showPrices to ensure clean calculation
    let calculatedSubtotal = 0;

    try {
        cartObject.items.forEach((cartLine) => {

            let cartLineElem = cartLinesContainerElem.querySelector(`[data-variant-id="${cartLine.variant_id}"]`)

            if (!cartLineElem) {
                cartLineElem = cartLinesContainerElem.querySelector(`[data-variant-id="${cartLine.product_id}"]`)
                if (!cartLineElem && DEBUG_MODE) {
                    throw new Error(`Error loading discounts on products, could not locate cart line, missing product id - ${cartLine.product_id}`)
                }
            };

            const priceElems = getLinePriceElements(cartLineElem)

            const qty = parseInt(cartLineElem.querySelector("input").value);
            const subtotalAmount = cartLine.final_price * qty

            calculatedSubtotal = calculatedSubtotal + subtotalAmount

            DEBUG_MODE && console.log("Unit price element", priceElems.unitPriceField)
            DEBUG_MODE && console.log("Subtotal element", priceElems.subtotalField)

            // Show prices on line            
            DEBUG_MODE && console.log("Updating subtotal price to be - ", displayPrice(subtotalAmount));
            priceElems.subtotalField.innerText = displayPrice(subtotalAmount);
            priceElems.subtotalField.style.fontWeight = 600
            DEBUG_MODE && console.log("Updating unit price to be - ", displayPrice(cartLine.final_price))
            priceElems.unitPriceField.innerText = displayPrice(cartLine.final_price);
            priceElems.unitPriceField.style.fontWeight = 600

            DEBUG_MODE && console.log("Check unit price field - ", priceElems.unitPriceField.innerText)
            DEBUG_MODE && console.log("Check subtotal field - ", priceElems.subtotalField.innerText)

            DEBUG_MODE && console.log("Check Unit price element", priceElems.unitPriceField)
            DEBUG_MODE && console.log("Check Subtotal element", priceElems.subtotalField)
        })

        // Set the global lineSubtotals to the calculated value
        DEBUG_MODE && console.log("Calculated subtotal for all lines (AIOD app): ", displayPrice(cartObject.total_subtotal_price));
        DEBUG_MODE && console.log("Calculated subtotal for all lines (Line calc): ", displayPrice(calculatedSubtotal));
        lineSubtotals = cartObject.total_subtotal_price ?? calculatedSubtotal;

        cartTotalChanges(cartObject)
        revealPrices()
        return 1
    } catch (error) {
        DEBUG_MODE && console.error("Error showing prices on products:", error);
        return 0
    }
}

const showShippingNotice = (cartData) => {
    DEBUG_MODE && console.log("show ship fired");
    const fst = FREE_SHIPPING_TOTAL;
    const sc = document.getElementById(noticeBannerId);
    sc.innerHTML = ``;

    const pt = document.getElementById("price-tier-notice");
    const li = pt.getAttribute("data-iacali") ?? "true";
    const wv = pt.getAttribute("data-page") ?? "false";
    pt.innerHTML = ``;

    const pe = cartData.items.reduce((total, item) => total + (item.final_line_price || 0), 0); // total in pence

    const p = justNumbers(pe / 100)

    const tier =
        p <= TIER_FIVE_LIMIT
            ? TIER_FIVE_LIMIT
            : p <= TIER_SEVENPOINTFIVE_LIMIT
                ? TIER_SEVENPOINTFIVE_LIMIT
                : TIER_TEN_LIMIT;

    const fin = formatFinance(fst - p);
    const finT = formatFinance(tier - p);

    DEBUG_MODE && console.log("Cart Total", p)
    DEBUG_MODE && console.log("Logged in discount tier -", p)

    if (p < fst) {
        let pg = (p / fst) * 100;
        sc.innerHTML = `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">Spend<strong id="shippingPrice"> ${fin} </strong>more for <strong>free shipping</strong>!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${pg < fst ? pg : 100
            }%" id="free-shipping-notice__bar"></div></div></div>`;
        sc.style.transform = "scaleY(1)";
    } else {
        sc.innerHTML = `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="20000"><div class="free-shipping-notice__heading mb-2 text-center"><strong id="shippingPrice">Your order is eligible for free shipping!</strong></div><div class="free-shipping-notice__bar mt-3" style="--progress: 100%" id="free-shipping-notice__bar"></div></div></div>`;
        sc.style.transform = "scaleY(1)";
    }

    tier <= 350 ? "" : "" ? "" : "";

    if (pt) {
        if (p < TIER_TEN_LIMIT) {
            let prg = (p / tier) * 100;

            const msg =
                tier <= 350
                    ? li === "false"
                        ? ``
                        : `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">You are<strong id="shippingPrice"> ${finT} </strong>away from our <strong>5%</strong> discount tier!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${prg}%" id="free-shipping-notice__bar"></div></div></div>`
                    : tier <= 1000
                        ? li === "false"
                            ? `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">Logged in customers would get <strong>5%</strong> off this order...${wv === "side-cart" ? "<br />" : " "
                            }<strong><a href="https://www.atlasflowers.co.uk/account/register" style="text-decoration:underline">Join Atlas Flowers</a></strong></div></div>`
                            : `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center"><strong>5% discount added to order total...</strong> spend<strong id="shippingPrice"> ${finT} </strong>more to reach our <strong>7.5%</strong> discount tier!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${prg}%" id="free-shipping-notice__bar"></div></div></div>`
                        : li === "false"
                            ? `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">Logged in customers would get <strong>7.5%</strong> off this order...${wv === "side-cart" ? "<br />" : " "
                            }<strong><a href="https://www.atlasflowers.co.uk/account/register" style="text-decoration:underline">Join Atlas Flowers</a></strong></div></div>`
                            : `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center"><strong>7.5% discount added to order total...</strong> spend<strong id="shippingPrice"> ${finT} </strong>more to reach our <strong>10%</strong> discount tier!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${prg}%" id="free-shipping-notice__bar"></div></div></div>`;

            DEBUG_MODE && console.log("Checking price tiers -", tier <= 350, li === "false", "\n", "MSG -", msg);

            pt.innerHTML = msg;
        } else {
            pt.innerHTML = `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center"><strong id="shippingPrice">You've qualified for 10% order discount!</strong></div><div class="free-shipping-notice__bar mt-3" style="--progress: 100%" id="free-shipping-notice__bar"></div></div></div>`;
            DEBUG_MODE && console.log("show ship finished");
        }
    }
};

// Loading
const setLoading = (show, param) => {
    const cartLinesContainerElem = document.getElementById(cartLinesContainerId)
    const loadingSpinners = cartLinesContainerElem.querySelectorAll(loadingOverlayClass);

    DEBUG_MODE && console.log(`${show ? "Showing" : "Hiding"} spinners... ${param}`);
    loadingSpinners.forEach((spinner) => {
        isLoading = show;
        if (show) {
            spinner.removeAttribute("hidden");
        } else {
            spinner.setAttribute("hidden", true);
        }
    });
}

// Fallback
const showFallback = (altMsg) => {
    DEBUG_MODE && console.log("Show fallback messages fired", altMsg)
    let fallbackMsg = "An error has occurred. Please refresh the page to see the correct prices. If this error persists, please contact us."

    if (altMsg) {
        fallbackMsg = altMsg;
    }

    const fallbackMsgElement = document.getElementById(noticeBannerId);

    if (fallbackMsgElement) {
        fallbackMsgElement.style.transform = "scale(1);";
        fallbackMsgElement.style.height = "100px";
        fallbackMsgElement.innerText = fallbackMsg;
    }

    DEBUG_MODE && console.log("reloading prices...")
    revealPrices(true);
    // console.log("Closing cart due to fallback error")
    // document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
}

// Triggers

const startCartFlow = async (type, changedVariantId = null) => {
    DEBUG_MODE && console.log("Starting cart flow -", type, changedVariantId ? `for variant ${changedVariantId}` : "for all items");
    lineSubtotals = 0;

    try {
        // Get the expected cart count from Shopify
        const currentQuantity = await getCurrentCartQuantity();
        if (currentQuantity === 0) {
            setLoading(false, "Empty cart");
            return;
        }

        DEBUG_MODE && console.log('📊 Starting cart flow', {
            shopifyCartQty: currentQuantity,
            discountAppQty: getCartItemQuantity(window.csapps),
            changedVariantId
        });

        const msStart = Date.now();
        // Wait for csapps to sync with that count
        const cartSync = await waitForCartSync(currentQuantity, 10000);

        if (!cartSync) throw new Error('Cart sync failed');

        const msEnd = (Date.now() - msStart);
        DEBUG_MODE && console.log("Cart sync time taken: ", msEnd, "ms");

        const discountObject = window.csapps;
        DEBUG_MODE && console.log("RAW CART", JSON.stringify(discountObject));

        if (!discountObject || !discountObject.cart || !discountObject.cart.items) {
            throw new Error('csapps object is missing required properties');
        }

        DEBUG_MODE && console.log("responseData", discountObject.fire_cart_ajax ? "fire_cart_ajax found" : "cdata not found");
        DEBUG_MODE && console.log("cartData", discountObject.cart);
        const dataRoot = discountObject.fire_cart_ajax ? discountObject.fire_cart_ajax.responseJSON.cdata : discountObject.cart;

        console.log("dataroot - ",
            "original_total_price:", dataRoot.original_total_price,
            "total_subtotal_price:", dataRoot.items_subtotal_price,
            "total_price:", dataRoot.total_price,
            "total_discount:", dataRoot.total_discount,
            "item_count:", dataRoot.item_count,
            "currency_symbol:", dataRoot.currency_symbol,
            "currency_code:", dataRoot.currency_code,
        );

        const lineData = dataRoot.items.map((item) => ({
            id: item.id,
            quantity: item.quantity,
            variant_id: item.variant_id,
            product_id: item.product_id,
            title: item.title,
            price: item.price,
            original_price: item.original_price,
            discounted_price: item.discounted_price,
            compare_at_price: item.product,
            line_price: item.line_price,
            original_line_price: item.original_line_price,
            final_price: item.final_price,
            final_line_price: item.final_line_price,
            line_level_discount_allocations: item.line_level_discount_allocations,
            line_level_total_discount: item.line_level_total_discount
        }));

        cartObject = {
            original_total_price: dataRoot.original_total_price,
            total_price: dataRoot.total_price,
            total_discount: dataRoot.total_discount,
            item_count: dataRoot.item_count,            
            total_subtotal_price: dataRoot.items_subtotal_price,
            // original_total_price: discountObject.cart.original_total_price,
            // total_price: discountObject.cart.total_price,
            // total_discount: discountObject.cart.total_discount,
            // item_count: discountObject.cart.item_count,
            currency_symbol: discountObject.currency_symbol,
            currency_code: discountObject.currency_code,
            items: lineData
        };

        const showPricesResult = showPrices(cartObject, changedVariantId);

        if (showPricesResult > 0) {
            showShippingNotice(cartObject);
            refreshAttempts = 0;
        } else {
            DEBUG_MODE && console.log("Throwing error to trigger fallback - prices failed to show correctly");
            throw new Error("Failed to show prices correctly - please refresh the page to see the correct prices, or contact us if this error persists.")
        }
    } catch (err) {
        DEBUG_MODE && console.log("fallback found");
        // cartLoadFallback(err)
        await handleCartError(err);
    } finally {
        setLoading(false, "Cart flow complete");

        const cartLinesContainerElem = document.getElementById(cartLinesContainerId);
        if (cartLinesContainerElem) {
            let cartLineElem = cartLinesContainerElem.querySelectorAll(`.cart-item__details`);

            cartLineElem.forEach((line) => {
                const lineName = line.querySelector(".cart-item__title")?.innerText ?? "Unknown product";
                const unitPriceElem = line.querySelector(`#lineUnit`);
                const subtotalElem = line.querySelector(lineSubtotalContainerId);

                DEBUG_MODE && console.log(`Line: ${lineName}`,
                    unitPriceElem?.innerText ?? "N/A",
                    subtotalElem?.innerText ?? "N/A"
                );
            });
        }
    };
}

// const cartLoadFallback = (error) => {

//     showFallback(`Error: ${error.message}`);

//     if (reloadCount >= 2) {
//         DEBUG_MODE && console.log("cart error - refreshing page", error);
//       DEBUG_MODE && console.log("Refresh disabled for testing")
//         // location.reload()        
//     } else {
//         // Relaod cart
//         setLoading(true, "cart refresh")
//         DEBUG_MODE && console.log("cart error - closing cart", error);
//         document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
//         setTimeout(async () => {
//           DEBUG_MODE && console.log("timeout")
//             DEBUG_MODE && console.log("cart error - cart opened", error);
//             refreshCart()
//             reloadCount++
//             document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
//             await startCartFlow("Refresh retry...")
//         }, 1500)
//     }
// }
const handleCartError = async (error) => {
    DEBUG_MODE && console.error("Handling cart error:", error.message);

    if (JSON.stringify(error.message).includes("The maximum quantity of this item is already in your cart.")) {
        DEBUG_MODE && console.log("Quantity error, no need to refresh cart");
        return;
    }

    // Prevent multiple simultaneous refreshes
    if (isRefreshing) {
        DEBUG_MODE && console.log("Already refreshing, skipping duplicate refresh");
        return;
    }

    // Check if we've exceeded max refresh attempts
    if (refreshAttempts >= MAX_REFRESH_ATTEMPTS) {
        DEBUG_MODE && console.log("Max refresh attempts reached, showing fallback");
        showFallback(`Unable to load cart prices. Please refresh the page or contact us if this persists.`);
        return;
    }

    // Attempt to refresh cart
    isRefreshing = true;
    refreshAttempts++;

    try {
        DEBUG_MODE && console.log(`Refresh attempt ${refreshAttempts}/${MAX_REFRESH_ATTEMPTS}`);

        setLoading(true, "Refreshing cart");

        // Close cart drawer if open
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));

        // Wait for drawer to close
        await new Promise(resolve => setTimeout(resolve, 300));

        // Refresh cart data
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
            bubbles: true
        }));

        // Wait for refresh to complete
        await new Promise(resolve => setTimeout(resolve, 500));

        // Reopen cart drawer if not on cart page
        if (!isCartPage) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
            await new Promise(resolve => setTimeout(resolve, 300));
        }

        // Retry cart flow
        await startCartFlow("Retry after error");

    } catch (retryError) {
        DEBUG_MODE && console.error("Retry failed:", retryError);
        showFallback(`Unable to load cart prices. Please refresh the page or contact us if this persists.`);
    } finally {
        isRefreshing = false;
    }
};

const refreshCart = async () => {
    if (isRefreshing) {
        DEBUG_MODE && console.log("Already refreshing, skipping");
        return;
    }

    isRefreshing = true;
    setLoading(true, "Manual cart refresh");
    DEBUG_MODE && console.log("Manually refreshing cart");

    try {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
            bubbles: true
        }));

        await new Promise(resolve => setTimeout(resolve, 500));

        DEBUG_MODE && console.log("Cart refreshed, reloading prices...");
        await startCartFlow("Manual refresh");
    } catch (error) {
        DEBUG_MODE && console.error("Manual refresh failed:", error);
        showFallback("Unable to refresh cart. Please reload the page.");
    } finally {
        isRefreshing = false;
    }
};

const updateQtyInputs = async () => {
    DEBUG_MODE && console.log("Shopify cart - ", shopifyCartObj)

    const cartLinesContainerElem = document.getElementById(cartLinesContainerId)
    let cartLineElem = cartLinesContainerElem.querySelectorAll('[data-variant-id]')

    let updatedCount = 0;

    cartLineElem.forEach((line) => {
        // Try to find by variant_id first, then fall back to product_id
        const variantId = line.dataset.variantId;
        const productId = line.dataset.productId;

        const shopifyCartRow = shopifyCartObj.items.find(item =>
            item.id == variantId || item.variant_id == variantId ||
            item.id == productId || item.product_id == productId
        );

        if (shopifyCartRow) {
            // Find the quantity input within this line
            const inputElement = line.querySelector('.qty-input__input');

            if (inputElement && shopifyCartRow.quantity) {
                const currentInputValue = parseInt(inputElement.value);
                const shopifyQuantity = parseInt(shopifyCartRow.quantity);

                // Only update if quantities are different
                if (currentInputValue !== shopifyQuantity) {
                    inputElement.value = shopifyQuantity;
                    updatedCount++;
                    DEBUG_MODE && console.log(`Updated quantity for variant ${variantId}: ${currentInputValue} → ${shopifyQuantity}`);
                }
            }
        }
    })

    DEBUG_MODE && console.log(`Updated ${updatedCount} quantity input(s)`);
    return updatedCount;
}


const path = window.location.pathname;
if (path === "/cart") {
    isCartPage = true;
    setLoading(true, "cart page loading")
} else {
    isCartPage = false;
}



document.addEventListener("DOMContentLoaded", async () => {
    DEBUG_MODE && console.log("DOMContentLoaded");

    if (isCartPage) {
        DEBUG_MODE && console.log("cart prices triggered automatically");
        await startCartFlow("cart page")
    } else {
        const openCartButton = document.getElementById("cart-icon")
        openCartButton.addEventListener('click', async (e) => {
            setLoading(true, "cart open")
            DEBUG_MODE && console.log("cart prices triggered by side cart open");
            await startCartFlow("side cart")
        });
    }

    document.addEventListener("on:line-item:change", async (e) => {
        DEBUG_MODE && console.log("changed", e);
        setLoading(true, "changed item")

        // Extract variant ID from event detail
        const variantId = e.detail?.id || e.detail?.variantId || null;
        DEBUG_MODE && console.log("Changed variant ID:", variantId);

        await startCartFlow("Changed item", variantId)
    });

    document.addEventListener("on:cart:add", async (e) => {
        DEBUG_MODE && console.log("Added", e);
        setLoading(true, "added item")

        // Extract variant ID from event detail
        const variantId = e.detail?.id || e.detail?.variantId || null;
        DEBUG_MODE && console.log("Added variant ID:", variantId);

        await startCartFlow("Item added", variantId)
    });

    document.addEventListener('on:cart-drawer:after-open', (event) => {
        DEBUG_MODE && console.log("Cart drawer opened");
        isCartOpen = true;
        refreshCart()
    });

    document.addEventListener('on:quickbuy:after-close', (event) => {
        DEBUG_MODE && console.log("Cart drawer closed");
        isCartOpen = false;
    });

    // Error in cart
    document.addEventListener("on:cart:error", async (err) => {
        DEBUG_MODE && console.log("Cart error event received:", err.detail);

        // Don't handle availability errors - let the existing handler deal with them
        if (err.detail?.error?.includes("items were added to your cart due to availability") || err.detail?.error?.includes("The maximum quantity of this item is already in your cart")) {
            DEBUG_MODE && console.log("Availability error - handled by existing system");

            setLoading(true, "Reloading after error")

            if (!isCartOpen && !isCartPage) {
                DEBUG_MODE && console.log("Is not cart page and cart is not open, redirecting to cart page to show error")
                // This is a brutal fix but maybe neccesary
                window.location.reload()
            } else {
                setTimeout(() => {
                    DEBUG_MODE && console.log("Attempting refresh here in cart drawer")
                    refreshCart()
                }, 3000)

            }
            return;
        }

        // Handle other cart errors
        await handleCartError(new Error(err.detail?.error || "Cart error occurred"));
    });
});